import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/instant-booking-logo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-782b491c")

_pushScopeId("data-v-782b491c")
const _hoisted_1 = { class: "flex items-center justify-between text-sm font-semibold" }
const _hoisted_2 = { class: "flex text-sm font-semibold" }
const _hoisted_3 = { class: "text-black-lp-100 pr-2 flex items-center" }
const _hoisted_4 = { class: "text-blue-lp-300 border-l-2 pl-2 flex flex-row items-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4 h-4 mr-1"
}, null, -1)
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "w-full flex flex-col text-12px" }
const _hoisted_8 = { class: "font-normal" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_10 = { class: "flex flex-row mt-1 items-start" }
const _hoisted_11 = { class: "flex items-center gap-1.5" }
const _hoisted_12 = {
  key: 0,
  class: "text-xs text-red-lp-1200 mt-1"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_LogProcessScanPanel = _resolveComponent("LogProcessScanPanel")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ModalTermCondition = _resolveComponent("ModalTermCondition")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, {
      rounded: "xl",
      class: "w-full flex flex-col p-2 mb-2",
      style: {
      backgroundImage: `url(${require('@/app/ui/assets/svg/bg-scan-shipment.svg')})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top right',
      backgroundSize: 'contain'
    }
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.scanLabel")), 1),
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("p", null, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.instantToggle")), 1),
              _createVNode("div", _hoisted_6, [
                _createVNode("img", {
                  src: require(`@/app/ui/assets/svg/info.svg`),
                  class: "ml-1 mr-2 h-4 xxl:h-5 cursor-pointer",
                  alt: "info",
                  onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTooltip($event))),
                  onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTooltip($event)))
                }, null, 40, ["src"]),
                _createVNode(_component_OverlayPanel, {
                  ref: "opTooltip",
                  appendTo: "body",
                  style: {
                backgroundColor: '#ffffff',
                color: '#4D4D4D',
                transform:
                  'scale(var(--viewport-scale)) translateX(calc((var(--viewport-scale) - 1) * 600px)) translateY(calc((var(--viewport-scale) - 1) * 100px))'
              }
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.tooltipScan")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _createVNode("div", {
                id: "toggle_booking_instant_create_shipment",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChangeToggle && _ctx.onChangeToggle(...args))),
                class: 
              `toggle-switch inline-block cursor-pointer ${
                _ctx.isInstantBooking
                  ? `toggle-active ${'bg-red-lp-100'}`
                  : `${'bg-gray-lp-200'}`
              }`
            
              }, [
                _hoisted_9
              ], 2)
            ])
          ]),
          _createVNode(_component_LogProcessScanPanel, { entries: _ctx.scanLogEntries }, null, 8, ["entries"])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", {
            class: [
          _ctx.duplicateError ? 'border-red-lp-100' : 'border-gray-lp-400',
          `input-with-icon flex-grow mr-4 py-1.5 xxl:py-2 pr-3 rounded-r-md border-r rounded-l-md border-l border-t border-b flex flex-wrap items-center gap-2 bg-white cursor-text focus-within:outline-none focus-within:shadow`
        ],
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.focusInput && _ctx.focusInput(...args)))
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelValue, (chip, index) => {
              return (_openBlock(), _createBlock(_component_Chips, {
                key: chip,
                padding: "px-2.5 py-0.5",
                color: "bg-gray-lp-1000",
                textColor: "black-lp-300"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("span", null, _toDisplayString(chip), 1),
                    _createVNode("button", {
                      type: "button",
                      class: "text-16px text-gray-lp-800 font-semibold leading-none",
                      onClick: _withModifiers(($event: any) => (_ctx.removeChip(index)), ["stop"])
                    }, " × ", 8, ["onClick"])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _withDirectives(_createVNode("input", {
              id: "input_shipment_id_create_shipment",
              ref: "input_shipment_id_create_shipment",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.inputValue = $event)),
              type: "text",
              disabled: _ctx.isLoading,
              placeholder: 
            _ctx.modelValue.length === 0
              ? 'Masukkan atau scan shipment/booking ID'
              : ''
          ,
              class: "flex-1 min-w-[140px] outline-none bg-transparent text-black-lp-300",
              onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onInputValue && _ctx.onInputValue(...args))),
              onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args))),
              onPaste: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onPaste && _ctx.onPaste(...args))),
              onKeyup: _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
            }, null, 40, ["disabled", "placeholder"]), [
              [_vModelText, _ctx.inputValue]
            ])
          ], 2),
          _createVNode(_component_lp_button, {
            id: "button_tambah_shipment_create_shipment",
            class: 
          `px-8 rounded-md flex flex-row justify-center align-middle ${
            !_ctx.modelValue.length || _ctx.isLoading ? `bg-gray-lp-600` : `bg-red-lp-100`
          }`
        ,
            "text-color": "white",
            title: _ctx.$t('bookingShipment.appsMarketplace.buttonAdd'),
            flat: "",
            onClick: _cache[10] || (_cache[10] = () => (_ctx.modelValue.length ? _ctx.fetchShipmentId() : null))
          }, null, 8, ["class", "title"])
        ]),
        (_ctx.duplicateError)
          ? (_openBlock(), _createBlock("p", _hoisted_12, _toDisplayString(_ctx.duplicateError), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["style"]),
    _createVNode(_component_ModalTermCondition, {
      isOpen: _ctx.isShowModalTermCondition,
      "onUpdate:isOpen": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isShowModalTermCondition = $event)),
      onConfirm: _ctx.onConfirm
    }, null, 8, ["isOpen", "onConfirm"])
  ], 64))
})